module.exports = __webpack_public_path__ + "/img/CFP-Labeled-CoGvA9.svg";